module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pickCoverType":"Choose the cover you want","providersStripHeader":"We compare insurance products from Irelands top insurance providers","accredited":"Accredited by the Commission for Regulation of Utilities","badge":"Bonkers Money Limited, trading as bonkers.ie, is regulated by the Central Bank of Ireland."}}')
  delete Component.options._Ctor
}
